export interface ConditionalProps {
    children: any;
    show: boolean;
}

const ConditionalWrapper = (props: ConditionalProps): JSX.Element => {
    if (!props.show) return <></>;

    return <>{props.children}</>;
};

export default ConditionalWrapper;